import { render } from "./CompanyDetails.vue?vue&type=template&id=089b5722&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"

import "./CompanyDetails.vue?vue&type=style&index=0&id=089b5722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089b5722"]])

export default __exports__